<div class="card card-wider card-cascade">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{getTitle()}}</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col" *ngIf="description" [innerHTML]="description"></div>
      </div>
      <div class="row">
          <app-scale-questions-list class="col" [Questions]="getQuestionsForAssessment()"></app-scale-questions-list>
      </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/assessment-questions-list/assessment-questions-list.component.html